import React from "react";

export default function RankingPositionBadge({ position }) {
  const medals = {
    1: "🥇",
    2: "🥈",
    3: "🥉",
  };

  if (medals[position]) {
    return <span className={`teacher-ranking-position-badge medal-${position}`}>{medals[position]}</span>;
  }

  return <span className="teacher-ranking-position-ordinal">{position}º</span>;
}
